<template>
  <div ref="touchsense">
    <transition-group name="swipeUp">
      <div v-for="(oLayer, i) in getLayerStack" class="stack-modal-wrapper" @click.self="close" :key="`modal-${i}`">
        <div class="stack-modal-inner" :class="{'tab-bar' : oLayer.hasTabBar}">
          <component :is="oLayer.component" :opts="oLayer.opts" v-on:close="close"/>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
  import Swipe from '@/components/v5/Swipe.vue';
  import Media from '@/components/v5/modals/Media.vue';
  import Message from '@/components/v5/modals/Message.vue';
  import Notifications from '@/components/v5/modals/Notifications.vue';
  import Unlock from '@/components/v5/modals/Unlock.vue';
  import RingProgress from '@/components/v5/modals/RingProgress.vue';
  import DownloadApp from '@/components/v5/modals/DownloadApp.vue';
  import Experience from '@/components/v5/modals/Experience.vue';
  import InviteAccepted from '@/components/v5/modals/InviteAccepted.vue';
  import StreakAchieved from '@/components/v5/modals/StreakAchieved.vue';
  import AppReview from '@/components/v5/modals/AppReview.vue';
  import AppReviewFeedback from '@/components/v5/modals/AppReviewFeedback.vue';

  // Story Hack
  import Story from 'app/components/_v3.3/news/story/Body';
  import LegacyArticle from '@/pages/Article.vue';

  // Pages
  import Mission from '@/pages/v5/Mission.vue';
  import Invite from '@/pages/v5/profile/Invite.vue';

  export default {
    data() {
      return {
        aLayerStack: [],
        startY: 0,
        aListenerRegistry: [],
        iScroll: 0,
        bDebounceClose: false,
      }
    },

    components: {
      Swipe,
      Media,
      Message,
      Notifications,
      Unlock,
      RingProgress,
      DownloadApp,
      Experience,
      InviteAccepted,
      StreakAchieved,
      AppReview,
      AppReviewFeedback,

      // Go Deeper - Story/Article/Topic Hack
      Story,
      LegacyArticle,
      
      // Pages
      Mission,
      Invite,
    },

    computed: {
      getLayerStack() {
        return this.aLayerStack || [];
      },
      iLayerStackHeight() {
        return this.aLayerStack.length;
      },
      isNewStackOpen() {
        return this.aLayerStack.filter((o) => {
          return o.component == 'swipe';
        }).length > 0;
      },
    },

    mounted () {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.close();
        }
      });

      this.EventBus.$on('layer:new', (oArgs) => {
        // console.log(`\x1b[36m[LAYER] -- New! ${oArgs.component} `, oArgs);
        this.aLayerStack.push(oArgs);
        // broadcast to other things (tabBar etc) what the current 'top' element is (pseudo-urls)
        this.EventBus.$emit('layer:top', oArgs);
      });

      // LOADING... 
      if (this.$route.fullPath.includes('/n/')) {
        this.EventBus.$emit('layer:new', {
          'component': 'swipe',
          'opts': {},
        });
      }

      this.$refs.touchsense?.addEventListener('touchstart', this.evxTouchStart);
      this.$refs.touchsense?.addEventListener('touchmove', this.evxTouchMove);

      // console.log(`\x1b[36m[LAYER] -- Touch monitoring UP`);

      this.EventBus.$on('layer:close', () => {
        this.close();
      });

      // console.log(`ON: stack:snap-scroll`);
      this.EventBus.$on('stack:snap-scroll', (oArgs) => {
        // console.log(oArgs);
        if (oArgs.scrollTop !== null) { // might be 0!
          // hack - snap them all to the top for now!
          let oWraps = this.$el?.getElementsByClassName('stack-modal-wrapper');
          // console.log(`Wraps: `, oWraps);
          for (let oWrap of oWraps) {
            // console.log(`SNAP: `, oWrap);
            oWrap.scrollTop = oArgs.scrollTop;
          }
        }
      });


      // console.log(`\x1b[36m[LAYER] -- Events UP: `, this.$refs.scrollsense);
      // console.log(this.evxScroll);
    },

    beforeDestroy() {
      this.$refs.touchsense?.removeEventListener('touchstart', this.evxTouchStart);
      this.$refs.touchsense?.removeEventListener('touchmove', this.evxTouchMove);
    },

    methods: {
      
      close() {
        // watch for a debounce lock
        if (this.bDebounceClose) {
          // console.log(`\x1b[36m[LAYER] -- (Debounce/Ignore)`);
          return;
        }

        // or set a debounce lock for 300ms
        this.bDebounceClose = true;
        setTimeout(() => {
          this.bDebounceClose = false;
        }, 300);

        // and close the top item
        const oClosing = this.aLayerStack.pop();

        // console.log(`\x1b[36m[LAYER] -- Close: `, oClosing);

        // callback!?
        if (oClosing.onClose) {
          oClosing.onClose();
        }

        if (oClosing?.component == 'swipe') {
          this.$router.push('/');
        }

        // broadcast to other things (tabBar etc) what the current 'top' element is (pseudo-urls)
        this.EventBus.$emit('layer:top', this.aLayerStack[this.aLayerStack.length - 1]);
      },

      closeAll() {
        this.aLayerStack = [];
      },

      evxScroll(e) {
        const currentScrollTop = e.target.scrollTop;
        const maxScroll = e.target.firstChild.clientHeight - window.innerHeight;
        const maxScrollPCX = currentScrollTop / maxScroll;

        this.iScroll = Math.min(100, Math.max(0, Math.round(maxScrollPCX * 100)));

        if (this.iScroll % 5 == 0) {
          this.EventBus.$emit('stack:scroll', {
            position: this.iScroll,
          });
        }

        // Watch scroll position for page end
        // console.log(`\x1b[36m[LAYER] -- ${currentScrollTop} / ${maxScroll} = ${iPX}%`);
      },
      evxTouchMove(e) {
        const currentY = e.touches[0].clientY;
        const wrapY = e.touches[0]?.target?.closest('.stack-modal-wrapper')?.scrollTop;
        const vectorY = this.startY - currentY;

        // console.log(`SCROLL!!`, wrapY, vectorY, currentY, this.startY);

        if (wrapY > 0){
          // we're busy down the page... ignore.
          return; 
        }

        if (vectorY > -150) {
          // too subtle... ignore!
          return;
        }

        // console.log(`\x1b[36m[LAYER] -- CLOSE Event!`, e.touches[0]?.target);
        this.close();
      }, 

      evxTouchStart(e) {
        this.startY = e.touches[0].clientY;
        // console.log(`SET START -- `, this.startY, e.touches[0].clientY, e); 
      }
    },

    watch: {
      $route(to) {
        if (to.fullPath.includes('/n/')) {
          if (this.isNewStackOpen) {
            // console.log(`\x1b[36m[LAYER] -- Ignoring /n navgiation multiple times`);
            return;
          }
          this.EventBus.$emit('layer:new', {
            'component': 'swipe',
            'opts': {},
          });
        } else {
          this.closeAll();
        }
      },
      iLayerStackHeight(to) {
        // console.log(`\x1b[36m[LAYER] -- Length change: ${to}`);
        if (to > 0) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'unset';
        }
      },
      getLayerStack() {
        this.$nextTick(() => {
          let oWraps = this.$el?.getElementsByClassName('stack-modal-wrapper');
          // console.log(`\x1b[36m[LAYER] -- WRAPS: `, oWraps);
          for (let oWrap of oWraps) {
            // only once
            if (this.aListenerRegistry.includes(oWrap)) {
              // console.log(`\x1b[36m[LAYER] -- Already tied: `, oWrap);
              continue;
            }
            // okay - attach
            // console.log(`\x1b[36m[LAYER] -- Attaching! :: `, oWrap);
            oWrap.addEventListener('scroll', this.evxScroll);
          }
        });
      } 
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .stack-modal-wrapper {

    position: fixed;
    overflow-y: auto;
    overflow-x: hidden; 
    inset: 0;
    z-index: 200;
    background: rgba(0,0,0,0.8);

    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox, Safari 18.2+, Chromium 121+ */
    &::-webkit-scrollbar { 
        display: none;  /* Older Safari and Chromium */
    }

    .desktop & {
      backdrop-filter: blur(3px);
    }
    
    .stack-modal-inner {
      // position: relative;
      
      @include palette-default;
      background: transparent; // + override something in @palette-default?
      backdrop-filter: blur(3px);
      .darkmode & {
        background: transparent; // + override something in @palette-default?
        backdrop-filter: blur(3px);
      }

      max-width: 50rem;
      min-height: 100%;

      .desktop & {
        max-width: 900px;
        margin-top: 1.5rem;
        min-height: calc(100% - 1.5rem);
        
        .darkmode & {
          background: rgba($neutral-200, .1);
          color: $neutral-600;
        }
      }

      margin: calc(env(safe-area-inset-top) + 1.5rem) auto 0 auto;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      overflow: hidden;
    }

    .desktop & {
      padding-left: 5em;
      padding-right: 5em;
    }
  }

  .desktop-next {
    position: sticky;
    z-index: 2;
    top: 15rem;
    right: -2.5rem;
    width: 5rem;
    height: 5rem;
    background: $yellow-tone-3;
  }
  // .fade-enter-active, .fade-leave-active {
  //   transition: background 2s ease-out;
  // }
  // .fade-enter, .fade-leave-to /* .swipeUp-leave-active below version 2.1.8 */ {
  //   background: rgba(0,0,0,0);
  // }


  .swipeUp-enter-active, .swipeUp-leave-active {
    transition: all .3s ease-out;
    background: rgba(0,0,0,0);
  }
  .swipeUp-enter, .swipeUp-leave-to /* .swipeUp-leave-active below version 2.1.8 */ {
    transform: translateY(100vh);
    background: rgba(0,0,0,0);
  }
</style>